import { ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'
import { Formik } from 'formik'

import { ScanToEarnContextWrapper } from './scan-to-earn-context.component'
import { scanToEarnSchema } from 'src/common/validations/scan-to-earn.validation'
import { IScanToEarnCreateForm } from 'src/types/scan-to-earn.type'
import { useCreateConsumerScan } from 'src/hooks'
import { joinAbsRoute } from 'src/common/utils'
import { ROUTES } from 'src/constants'

interface IProps {
  children: ReactNode
}

export const SCAN_TO_EARN_FORM_INITIAL = {
  barcode_value: '',
  company_name: '',
  product_name: '',
  summary: '',
  media: [],
  impacts: [],
  new_impacts: [],
}

export const SCAN_TO_EARN_FORM_INITIAL_WITH_COORDS = {
  ...SCAN_TO_EARN_FORM_INITIAL,
  coords: { latitude: 0, longitude: 0 },
}

export const FormWrapper = ({ children }: IProps) => {
  const navigate = useNavigate()

  const { mutateAsync: createConsumerScan } = useCreateConsumerScan()

  const handleSubmit = async (values: IScanToEarnCreateForm) => {
    const { barcode_value, ...rest } = values
    const resp = await createConsumerScan({
      ...rest,
      barcode_id: barcode_value,
    })
    if (!resp) return

    navigate(joinAbsRoute(ROUTES.USER, ROUTES.SCAN_HISTORY))
  }

  return (
    <Formik
      enableReinitialize={false}
      validationSchema={scanToEarnSchema}
      onSubmit={handleSubmit}
      initialValues={SCAN_TO_EARN_FORM_INITIAL_WITH_COORDS}
    >
      {({ resetForm }) => {
        return <ScanToEarnContextWrapper resetForm={resetForm}>{children}</ScanToEarnContextWrapper>
      }}
    </Formik>
  )
}
